import { PdfGen, PdfUnit, PdfSize, PdfRect, PdfPoint } from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { IItemCount } from '@educraft/base';
import { OptsLabel } from '../optsLabel';
import { GUtil } from '../../pdf/gutil';
import '../../pdf/draw/primitives';
import '../../pdf/draw/label';

/**
 * Prekvapik__2 (Surprise 2) - Foldable surprise card (portrait)
 *
 * Layout: 1 portrait page with 10 specific rect positions forming
 * a foldable card pattern.
 *
 * Migrated from C# EduFrame.Img10.Generators.Prekvapik__2
 */
export class Prekvapik__2 implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 10;
  }
  countMax(): number {
    return 10;
  }

  public async generate(pdf: PdfGen, opts: OptsLabel): Promise<void> {
    const page = pdf.addPage();
    const margin = PdfUnit.FromMillimeters(5);
    const size = { width: PdfSize.A4.width / 4, height: PdfSize.A4.height / 4 };
    const size3 = { width: PdfSize.A4.width / 4, height: PdfSize.A4.height / 2 / 3 };

    const drawItem = (rect: PdfRect, index: number) => {
      if (index >= opts.list.length) return;
      const r = new PdfRect(
        rect.x + margin,
        rect.y + margin,
        rect.width - 2 * margin,
        rect.height - 2 * margin
      );
      page.drawLabel(opts.list[index].left, { rect: r });
      page.drawRectangle(GUtil.foldPen, null, rect);
    };

    // Top row: positions 0, 1
    drawItem(new PdfRect(size.width, 0, size.width, size.height), 0);
    drawItem(new PdfRect(size.width * 2, 0, size.width, size.height), 1);

    // Left column: positions 2, 3, 4
    drawItem(new PdfRect(0, size.height, size3.width, size3.height), 2);
    drawItem(new PdfRect(0, size.height + size3.height, size3.width, size3.height), 3);
    drawItem(new PdfRect(0, size.height + size3.height * 2, size3.width, size3.height), 4);

    // Bottom row: positions 5, 6
    drawItem(new PdfRect(size.width, size.height * 3, size.width, size.height), 5);
    drawItem(new PdfRect(size.width * 2, size.height * 3, size.width, size.height), 6);

    // Right column: positions 7, 8, 9
    drawItem(new PdfRect(size.width * 3, size.height, size3.width, size3.height), 7);
    drawItem(new PdfRect(size.width * 3, size.height + size3.height, size3.width, size3.height), 8);
    drawItem(
      new PdfRect(size.width * 3, size.height + size3.height * 2, size3.width, size3.height),
      9
    );
  }
}
